import UnicornApp from '../app';
import { defaultsDeep, each } from 'lodash-es';
export default class UnicornAnimate {
    app;
    static install(app) {
        const self = app.$animate = new this(app);
        app.animate = self.to.bind(self);
    }
    constructor(app) {
        this.app = app;
        //
    }
    to(element, styles, options = {}) {
        element = this.app.selectOne(element);
        const currentStyles = window.getComputedStyle(element);
        const transitions = {};
        each(styles, (value, name) => {
            transitions[name] = Array.isArray(value)
                ? value
                : [
                    currentStyles.getPropertyValue(name),
                    value
                ];
        });
        if (typeof options === 'number') {
            options = { duration: options };
        }
        options = defaultsDeep(options, {
            duration: 400,
            easing: 'linear',
            fill: 'both'
        });
        const animation = element.animate(transitions, options);
        animation.addEventListener('finish', () => {
            each(styles, (value, name) => {
                element.style.setProperty(name, Array.isArray(value)
                    ? value[value.length - 1]
                    : value);
            });
            animation.cancel();
        });
        return animation;
    }
    getCurrentStyle(element, name) {
        return window.getComputedStyle(element)[name];
    }
}
// declare global {
//   interface UnicornApp {
//     $animate: UnicornAnimate;
//     animate: typeof UnicornAnimate.prototype.to;
//   }
// }
